import { TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SFX from "Data/SoundEffect";
import * as VO from "Data/VoiceOver";
import * as Topics from "Data/Topics";
import Settings from "Data/Settings";
import { RestStopFreePlayCompletePopupLayout } from "Layouts/RestStopFreePlayCompletePopupLayout";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { IRuntimeDuck } from "Data/GameState";
import { LayoutNineSliceSprite } from "GameObjects/UI/LayoutNineSliceSprite";
import { templateResources } from "Data/templateResources";
import { ResourceType } from "Data/ResourceType";
import { BadgePopupLayout } from "../Layouts/BadgePopupLayout";
import GameState from "../Data/GameState";
import { Application } from "Application";
import { LayoutBitmapText } from "GameObjects/UI/LayoutBitmapText";
import { FreePlayMenu } from "States/FreePlayMenu";
import { LoadScreen } from "States/LoadScreen";
import { RestStopGame } from "States/RestStopGame";

export default class RestStopFreePlayCompletePopup extends HLF.Popup implements ReturnType<typeof RestStopFreePlayCompletePopupLayout> {
    public static readonly NAME = "RestStopFreePlayCompletePopup";

    public readonly bg: LayoutSprite;
    public readonly homeButton: LayoutButton;
    public readonly buttonFive: LayoutButton;
    public readonly buttonSeven: LayoutButton;
    public readonly buttonNine: LayoutButton;

    protected homeButtonLeftMargin: number = 0;

    public constructor() {
        super();
        this.bg = new LayoutSprite();
        this.homeButton = new LayoutButton(this.onHomeButtonPressed.bind(this), VO.HOME_BUTTON_HOVER, SFX.UI_CLICK);

        this.buttonFive = new LayoutButton(this.onPlayAgainFiveDucksButtonClicked.bind(this), [VO.REWARD_PLAY_AGAIN_HOVER, VO.DUCKNUM_5], SFX.UI_CLICK);
        this.buttonSeven = new LayoutButton(this.onPlayAgainSevenDucksButtonClicked.bind(this), [VO.REWARD_PLAY_AGAIN_HOVER, VO.DUCKNUM_7], SFX.UI_CLICK);
        this.buttonNine = new LayoutButton(this.onPlayAgainNineDucksButtonClicked.bind(this), [VO.REWARD_PLAY_AGAIN_HOVER, VO.DUCKNUM_9], SFX.UI_CLICK);
    }

    public init(pSize: PIXI.Point) {
        RestStopFreePlayCompletePopupLayout.call(this);
        this.homeButtonLeftMargin = this.homeButton.x;
        this.addChild(this.bg);
        this.addChild(this.homeButton);
        this.addChild(this.buttonFive);
        this.addChild(this.buttonSeven);
        this.addChild(this.buttonNine);

        const titleText = this.addChild(HLF.PixiUtils.makeText("Play Again?", Constants.FONT_RIFFICFREE_BOLD_36, 56, 0x000000));
        titleText.position.x = 512;
        titleText.position.y = 85;

        super.init(pSize); // calls onResize
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set(-1024 / 2, -768 / 2);
        this.homeButton.position.x = -((pSize.x - 1024) / 2) + this.homeButtonLeftMargin;
    }

    public show(pToken: HLF.IPopupToken) {
        super.show(pToken);
        console.log(pToken.data);
    }

    public gotoNextState(name: string, data?: object) {
        HLF.Application.instance.voiceover.stopVO();
        PubSub.publishSync(HLF.STOP_CAPTION);
        PubSub.publishSync(HLF.UNREGISTER_ALL_FOCUSABLES);
        const steps = [
            HLF.TransitionStep.AnimCurrentOut,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.AttachNewBehind,
            HLF.TransitionStep.AnimNewIn,
            HLF.TransitionStep.HideLoadScreen,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data: {name, ...data}}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken({id: name, data: {name}}, LoadScreen.NAME, ...steps),
        );
        this.hide();
    }

    protected AnimateIn(pCallback: () => void): void {
        TweenLite.fromTo(this, 0.5, {pixi: {alpha: 0}}, {pixi: {alpha: 1}}).eventCallback(Constants.TWEEN_ONCOMPLETE, ()=>{
            PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER);
            PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
                this.homeButton,
                this.buttonFive,
                this.buttonSeven,
                this.buttonNine,
            ]);
            pCallback();
        });
    }

    protected AnimateOut(pCallback: () => void): void {
        PubSub.publishSync(HLF.POP_KEYBOARD_LAYER);
        TweenLite.to(this, 0.5, {pixi: {alpha: 0}}).eventCallback(Constants.TWEEN_ONCOMPLETE, pCallback);
    }

    protected onHomeButtonPressed(): void {
        this.gotoNextState(FreePlayMenu.NAME);
    }


    protected onPlayAgainFiveDucksButtonClicked() {
        Settings.difficulty = 1/3;
        this.playAgain(5);
    }

    protected onPlayAgainSevenDucksButtonClicked() {
        Settings.difficulty = 2/3;
        this.playAgain(7);
    }

    protected onPlayAgainNineDucksButtonClicked() {
        Settings.difficulty = 3/3;
        this.playAgain(9);
    }

    protected playAgain(pHowManyDucks: number) {
        GameState.flyingTimeElapsed = 0;
        // reset badges
        GameState.dodgedAllObstacles = true;
        GameState.perfectPonds = true;
        GameState.swaptastic = true;

        this.gotoNextState(RestStopGame.NAME, {ducks: GameState.GetDucks(pHowManyDucks)});
    }

}